
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punecabservice() {



    const cardData =
    {
        keyword: 'Pune Cab Service',
        heading: 'Platinum24 Cabs: Pune Cab Service',
        headingDescription: 'Platinum24 Cabs provides trusted Pune Cab Service for local and outstation travel needs. Whether you require a quick city ride, airport transfer, business trip, or a long-distance journey, our fleet of hatchbacks, sedans, SUVs, and luxury cars ensures a comfortable travel experience. With professional drivers, clean and well-maintained vehicles, and transparent pricing, we deliver reliable cab services that fit every budget. From solo travelers to families and corporate groups, Platinum24 Cabs is your dependable travel partner in Pune, ensuring safety, punctuality, and hassle-free rides across all routes.',

        top: 'Top Places to Visit in Pune with Platinum24 Cabs',

       "topPlaces": [
  {
    "title": "Shaniwar Wada",
    "description": "Built in 1732 by the Peshwas, Shaniwar Wada is Pune’s most iconic fort palace and a proud symbol of Maratha heritage. Its massive gates, fountains, and courtyards echo tales of the Maratha Empire. Though partially destroyed by fire in 1828, it still attracts thousands of tourists daily. The light-and-sound show narrates the story of Bajirao and Mastani. Visitors enjoy exploring its ruins and lush gardens. Shaniwar Wada is Pune’s cultural crown jewel."
  },
  {
    "title": "Aga Khan Palace",
    "description": "The Aga Khan Palace, built in 1892, is an important landmark in India’s freedom struggle. Mahatma Gandhi, Kasturba Gandhi, and other leaders were imprisoned here during the Quit India Movement. Today, it houses a museum displaying Gandhi’s personal belongings and photographs. The palace’s Italian arches and sprawling gardens make it a peaceful retreat. Tourists admire both its historic and architectural significance. Aga Khan Palace is Pune’s proud heritage of patriotism."
  },
  {
    "title": "Sinhagad Fort",
    "description": "Sinhagad Fort, located 25 km from Pune, is a hill fortress famous for the 1670 battle where Tanaji Malusare fought for Chhatrapati Shivaji Maharaj. Trekkers climb the rugged paths for panoramic views of the Sahyadri ranges. The fort’s gates, bastions, and temples narrate stories of bravery. Monsoon brings mist, greenery, and waterfalls, making it especially scenic. Local vendors serve traditional pithla-bhakri at the top. Sinhagad Fort is Pune’s perfect blend of history and adventure."
  },
  {
    "title": "Dagdusheth Halwai Ganpati Temple",
    "description": "The Shreemant Dagdusheth Halwai Ganpati Temple is Pune’s most revered shrine dedicated to Lord Ganesha. Established over 125 years ago, the grand idol adorned with gold ornaments is a divine sight. During Ganesh Chaturthi, the temple becomes the epicenter of celebrations, attracting lakhs of devotees. The temple is also known for its charitable and cultural initiatives. Its spiritual aura makes it a must-visit for pilgrims and tourists. Dagdusheth is Pune’s divine cultural heart."
  },
  {
    "title": "Pataleshwar Cave Temple",
    "description": "Pataleshwar Cave Temple, carved in the 8th century, is a rock-cut shrine dedicated to Lord Shiva. Its massive stone pillars, sanctum, and Nandi mandapa showcase ancient Indian craftsmanship. Located in the heart of the city, it offers peace and spiritual calm amidst urban chaos. Evening prayers add to its mystical atmosphere. History enthusiasts admire its simple yet powerful design. Pataleshwar is Pune’s hidden gem of spirituality and heritage."
  },
  {
    "title": "Raja Dinkar Kelkar Museum",
    "description": "The Raja Dinkar Kelkar Museum is a cultural treasure housing over 20,000 artifacts collected by Dr. Dinkar Kelkar. It includes ornaments, sculptures, musical instruments, and household antiques. A highlight is the recreated Mastani Mahal, reflecting the Maratha era’s grandeur. Students and art lovers find it educational and fascinating. The museum preserves India’s traditions under one roof. It is Pune’s proud showcase of history and culture."
  },
  {
    "title": "Parvati Hill and Temple",
    "description": "Parvati Hill, one of Pune’s oldest landmarks, offers panoramic views of the city. The hilltop temple complex, built by the Peshwas, is dedicated to Lord Shiva and Goddess Parvati. Smaller shrines and a museum add to its heritage significance. Visitors climb 103 steps to reach the temple, combining devotion with scenic charm. Sunrises and sunsets from the top are breathtaking. Parvati Hill is Pune’s sacred and scenic retreat."
  },
  {
    "title": "Osho Ashram",
    "description": "The Osho International Meditation Resort in Koregaon Park is a global center for spirituality and wellness. Spread across lush gardens, it attracts seekers from all over the world. The ashram offers meditation, yoga, and personal growth workshops. Japanese Zen gardens and serene meditation halls enhance the experience. It is both a wellness retreat and a spiritual destination. Osho Ashram is Pune’s international hub of peace and mindfulness."
  },
  {
    "title": "Pu La Deshpande Garden",
    "description": "Pu La Deshpande Garden, inspired by Japan’s Korakuen Garden, is Pune’s largest landscaped park. With flowing streams, stone bridges, and manicured lawns, it is a favorite for families and nature lovers. Seasonal flowers and lush greenery make it picturesque year-round. Families enjoy picnics, photography, and peaceful strolls here. It also symbolizes Indo-Japanese cultural friendship. Pu La Deshpande Garden is Pune’s green paradise of beauty and calm."
  },
  {
    "title": "Khadakwasla Dam",
    "description": "Khadakwasla Dam, built on the Mutha River, is a popular weekend retreat near Pune. It supplies water to the city while offering scenic views of hills and flowing waters. During monsoon, the overflowing dam creates a spectacular sight. Families enjoy roadside snacks like roasted corn and hot tea here. It is also the gateway to Sinhagad Fort treks. Khadakwasla is Pune’s refreshing natural escape for families and travelers alike."
  }
],



      "services": [
    {
        "name": "Pune Cab Service",
        "description": "Reliable Pune cab service offering local and outstation travel options with well-maintained vehicles and professional drivers. Ideal for daily commutes, business trips, or leisure travel."
    },
    {
        "name": "Pune Taxi Service",
        "description": "Professional taxi service in Pune providing 24/7 availability, comfortable rides, and prompt pickups for both city and intercity travel needs."
    },
    {
        "name": "Pune Car Rentals",
        "description": "Flexible car rental services in Pune with a wide range of vehicles available for self-drive or chauffeur-driven options. Perfect for both short and long-term rentals."
    },
    {
        "name": "Pune Airport Taxi",
        "description": "Timely and convenient airport taxi service in Pune, ensuring smooth transfers to and from Pune Airport with fixed rates and no hidden charges."
    },
    {
        "name": "Pune Local Cabs",
        "description": "Affordable and reliable local cab services in Pune for city tours, shopping, meetings, and daily travel. Available by the hour or for full-day packages."
    },
    {
        "name": "Taxi Booking Pune",
        "description": "Easy and fast online taxi booking in Pune with instant confirmation and multiple payment options. Book your ride in just a few clicks."
    },
    {
        "name": "Pune Chauffeur Service",
        "description": "Premium chauffeur-driven car services in Pune offering luxury vehicles and trained drivers for business travel, special events, and VIP transfers."
    },
    {
        "name": "Affordable Cabs Pune",
        "description": "Low-cost cab services in Pune without compromising on comfort or safety. Transparent pricing with budget-friendly options for all types of travelers."
    },
    {
        "name": "Pune Ride Service",
        "description": "On-demand ride services in Pune with quick pickups, clean cars, and courteous drivers. Suitable for solo travelers, families, or groups."
    },
    {
        "name": "Pune Taxi Booking Online",
        "description": "Seamless online platform for booking taxis in Pune with real-time availability, competitive pricing, and responsive customer support."
    },
    {
        "name": "Pune to Shirdi Cab",
        "description": "Convenient cab service from Pune to Shirdi with experienced drivers and comfortable vehicles. Ideal for pilgrimage and leisure trips."
    },
    {
        "name": "Pune to Mumbai Cab",
        "description": "Safe and comfortable cab options for travel between Pune and Mumbai, offering door-to-door service with flexible booking slots."
    },
    {
        "name": "Pune to Mumbai Airport Cab",
        "description": "Dedicated cab service from Pune to Mumbai Airport with punctual pickups and spacious vehicles for luggage and passengers."
    },
    {
        "name": "Pune to Mahabaleshwar Cab",
        "description": "Scenic cab journeys from Pune to Mahabaleshwar with knowledgeable drivers who ensure a relaxing and enjoyable ride."
    },
    {
        "name": "Pune to Shirdi Taxi",
        "description": "Taxi services from Pune to Shirdi providing both one-way and round-trip options. Comfortable cars and affordable pricing for pilgrims and tourists."
    },
    {
        "name": "Taxi Service in Pune",
        "description": "Versatile taxi services across Pune covering local, airport, and intercity travel with easy booking and reliable service."
    },
    {
        "name": "Pune to Bhimashankar Cab",
        "description": "Cab services from Pune to Bhimashankar, ideal for spiritual tours and nature trips. Well-maintained vehicles and experienced drivers."
    },
    {
        "name": "Pune to Mumbai Taxi",
        "description": "Taxi options from Pune to Mumbai offering fixed fares, clean cars, and professional service. Available for both business and personal travel."
    },
    {
        "name": "Cab Booking in Pune",
        "description": "User-friendly cab booking service in Pune with real-time vehicle tracking, transparent pricing, and professional drivers."
    },
    {
        "name": "Pune to Kolhapur Cab",
        "description": "Comfortable cab rides from Pune to Kolhapur with door-to-door pickup and flexible departure times. Suitable for families and group travel."
    },
    {
        "name": "Cheapest Cab Service in Pune",
        "description": "Pocket-friendly cab services in Pune with the best rates for local and outstation travel. Enjoy comfort and reliability at minimal costs."
    }
],
"tableData": [
    ["Pune Cab Service", "Pune Taxi Service"],
    ["Pune Car Rentals", "Pune Airport Taxi"],
    ["Pune Local Cabs", "Taxi Booking Pune"],
    ["Pune Chauffeur Service", "Affordable Cabs Pune"],
    ["Pune Ride Service", "Pune Taxi Booking Online"],
    ["Pune to Shirdi Cab", "Pune to Mumbai Cab"],
    ["Pune to Mumbai Airport Cab", "Pune to Mahabaleshwar Cab"],
    ["Pune to Shirdi Taxi", "Taxi Service in Pune"],
    ["Pune to Bhimashankar Cab", "Pune to Mumbai Taxi"],
    ["Cab Booking in Pune", "Pune to Kolhapur Cab"],
    ["Cheapest Cab Service in Pune"]
],


        "whychoose": [
    {
        "WhyChooseheading": "Reliable and Affordable Pune Cab Service",
        "WhyChoosedescription": "Platinum24 Cabs provides dependable and budget-friendly cab services across Pune, ensuring a comfortable ride every time."
    },
    {
        "WhyChooseheading": "Wide Range of Cabs for Every Travel Need",
        "WhyChoosedescription": "From sedans to SUVs, we offer a diverse fleet to suit your individual, family, or business travel requirements within Pune."
    },
    {
        "WhyChooseheading": "Clean, Well-Maintained Vehicles",
        "WhyChoosedescription": "All our cabs undergo regular cleaning and maintenance to guarantee hygiene, safety, and smooth rides across the city."
    },
    {
        "WhyChooseheading": "Professional Drivers with Local Expertise",
        "WhyChoosedescription": "Our courteous and experienced drivers know Pune inside out, ensuring timely pickups and efficient routes."
    },
    {
        "WhyChooseheading": "Flexible Booking Options for Daily and Hourly Rides",
        "WhyChoosedescription": "Choose from hourly packages or full-day rentals to match your schedule, whether for work, shopping, or leisure travel."
    },
    {
        "WhyChooseheading": "Transparent Pricing with No Hidden Charges",
        "WhyChoosedescription": "Enjoy honest, upfront pricing on all rides—no surprises, just reliable cab service in Pune."
    },
    {
        "WhyChooseheading": "Perfect for Airport Transfers, Office Commutes, and City Tours",
        "WhyChoosedescription": "Whether you're catching a flight, heading to work, or exploring Pune, we’ve got the right cab for you."
    },
    {
        "WhyChooseheading": "24/7 Customer Support for Smooth Ride Experience",
        "WhyChoosedescription": "Our support team is available round-the-clock to help with bookings, trip updates, or any special requests."
    }
]











    }


    const faqData = [
    {
        question: 'Does Platinum24 Cabs offer cab services within Pune?',
        answer: 'Yes, Platinum24 Cabs provides reliable and prompt cab services across Pune for daily commuting, business travel, and personal trips.',
    },
    {
        question: 'How can I book a cab with Platinum24 Cabs in Pune?',
        answer: 'You can easily book a cab through our website, mobile app, or by contacting our 24/7 customer support team.',
    },
    {
        question: 'Are Platinum24 Cabs available for airport transfers in Pune?',
        answer: 'Absolutely! We offer timely and hassle-free airport pick-up and drop-off services across all major areas in Pune.',
    },
    {
        question: 'What types of cabs are available with Platinum24 Cabs in Pune?',
        answer: 'We offer a wide range of vehicles including hatchbacks, sedans, SUVs, and premium cars to suit your travel needs.',
    },
    {
        question: 'Do Platinum24 Cabs offer hourly rental options in Pune?',
        answer: 'Yes, we provide flexible hourly rental packages ideal for local sightseeing, meetings, and day-long travel in Pune.',
    },
    {
        question: 'Are the drivers at Platinum24 Cabs professional and trained?',
        answer: 'Yes, all our drivers are well-trained, courteous, and familiar with all routes in and around Pune.',
    },
    {
        question: 'Can I schedule a ride in advance with Platinum24 Cabs?',
        answer: 'Yes, you can pre-book your rides through our app or website to ensure timely pickup as per your schedule.',
    },
    {
        question: 'Is there a customer support helpline for Pune Cab Services?',
        answer: 'Yes, our dedicated customer support team is available 24/7 to assist you with bookings, queries, or ride-related concerns.',
    },
    {
        question: 'Are Platinum24 Cabs sanitized and safe for travel?',
        answer: 'All our vehicles undergo regular cleaning and sanitization. We follow strict hygiene and safety protocols for your well-being.',
    },
    {
        question: 'Do Platinum24 Cabs operate in nearby areas around Pune?',
        answer: 'Yes, we also provide cab services to nearby towns and suburbs including Pimpri-Chinchwad, Hinjewadi, and more.',
    },
];

const testimonials = [
    {
        id: 1,
        name: 'Mr. Rohit Kulkarni',
        feedback: 'I used Platinum24 Cabs for a local Pune trip and was impressed by the punctuality and professionalism. Great service!',
        rating: 5,
    },
    {
        id: 2,
        name: 'Ms. Anjali Deshmukh',
        feedback: 'Clean car, polite driver, and timely pickup – Platinum24 Cabs made my airport transfer in Pune completely stress-free!',
        rating: 5,
    },
];


























    const Images = [
        { place: "/images/keyword/1.jpg", text: "Pune Cab Service", link: "pune-cab-service" },
        { place: "/images/keyword/2.jpg", text: "Pune Taxi Hire", link: "pune-taxi-hire" },
        { place: "/images/keyword/3.jpg", text: "Pune Online Cab Booking", link: "pune-online-cab-booking" },
        { place: "/images/keyword/4.jpg", text: "Best Cab Service in Pune", link: "best-cab-service-in-pune" },
        { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Cabs", link: "pune-to-mumbai-cabs" },
        { place: "/images/keyword/6.jpg", text: "Pune to Nashik Cabs", link: "pune-to-nashik-cabs" },
        { place: "/images/keyword/7.jpg", text: "Pune to Mahabaleshwar Cabs", link: "pune-to-mahabaleshwar-cabs" },
        { place: "/images/keyword/8.jpg", text: "Pune to Lonavala Cabs", link: "pune-to-lonavala-cabs" },
        { place: "/images/keyword/9.jpg", text: "Pune to Shirdi Cab", link: "pune-to-shirdi-cab" },
        { place: "/images/keyword/10.jpg", text: "Pune to Bhimashankar Cab", link: "pune-to-bhimashankar-cab" },
        { place: "/images/keyword/11.jpg", text: "Pune to Konkan Darshan Cabs", link: "pune-to-konkan-darshan-cabs" },
        { place: "/images/keyword/12.jpg", text: "Pune Outstation Cabs", link: "pune-outstation-cabs" },
        { place: "/images/keyword/13.jpg", text: "Ashtavinayak Darshan Cab", link: "ashtavinayak-darshan-cab" },
        { place: "/images/keyword/14.jpg", text: "Pune to Goa Cabs", link: "pune-to-goa-cabs" },
        { place: "/images/keyword/15.jpg", text: "Cabs Services Near Me", link: "cabs-services-near-me" },
        { place: "/images/keyword/16.jpg", text: "Corporate Cab Service in Pune", link: "corporate-cab-service-in-pune" },
        { place: "/images/keyword/17.jpg", text: "Pune to Mumbai Airport Cabs", link: "pune-to-mumbai-airport-cabs" },
        { place: "/images/keyword/18.jpg", text: "Tempo Traveller On Rent in Pune", link: "tempo-traveller-on-rent-in-pune" },
        { place: "/images/keyword/19.jpg", text: "Urbania On Rent in Pune", link: "urbania-on-rent-in-pune" },
        { place: "/images/keyword/20.jpg", text: "Innova Crysta On Rent in Pune", link: "innova-crysta-on-rent-in-pune" },
        { place: "/images/keyword/21.jpg", text: "Bus On Rent in Pimpri Chinchwad", link: "bus-on-rent-in-pimpri-chinchwad" },
        { place: "/images/keyword/22.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
        { place: "/images/keyword/23.jpg", text: "Ertiga On Rent in Pune", link: "ertiga-on-rent-in-pune" },
        { place: "/images/keyword/24.jpg", text: "Pune to Sambhaji Nagar Taxi", link: "pune-to-sambhaji-nagar-taxi" },
        { place: "/images/keyword/25.jpg", text: "Pune to Ganpatipule Taxi", link: "pune-to-ganpatipule-taxi" }
    ];








const puneCabServiceSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune Cab Service",
  "image": "https://www.platinum24cab.com/assets/images/pune-cab-service.jpg",
  "description": "Book Pune cab service with Platinum24 Cabs. Choose from AC sedans, SUVs, and more for local, outstation, airport transfers, and chauffeur services. Affordable and reliable taxi options available 24/7.",
  "brand": {
    "@type": "Brand",
    "name": "Platinum24 Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.8",
    "ratingCount": "32150",
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "999",
    "availability": "https://schema.org/InStock",
    "url": "https://www.platinum24cab.com/pune-cab-service"
  }
};






    return (
        <div>
<Helmet>
  <title>Pune Cab Service | Affordable Taxi & Car Rentals | Platinum24 Cabs</title>
  <meta
    name="description"
    content="Book Pune cab service with Platinum24 Cabs. Choose from AC sedans, SUVs, and more for local, outstation, airport transfers, and chauffeur services. Affordable and reliable taxi options available 24/7."
  />
  <meta
    name="keywords"
    content="Pune Cab Service, Pune Taxi Service, Pune Car Rentals, Pune Airport Taxi, Pune Local Cabs, Taxi Booking Pune, Pune Chauffeur Service, Affordable Cabs Pune, Pune Ride Service, Pune Taxi Booking Online, Pune to Shirdi Cab, Pune to Mumbai Cab, Pune to Mumbai Airport Cab, Pune to Mahabaleshwar cab, Pune to Shirdi Taxi, Taxi Service in Pune, Pune to Bhimashankar Cab, Pune to Mumbai Taxi, Cab Booking in Pune, Pune to Kolhapur Cab, Cheapest Cab Service in Pune"
  />
  <script type="application/ld+json">
    {JSON.stringify(puneCabServiceSchema)}
  </script>
</Helmet>


            <div
                className="breadcumb-wrapper"
                // style={{ backgroundImage: "url('/img/breadcumb/breadcumb-bg.jpg')" }}
            >
                <div className="container z-index-common">
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title">{cardData.keyword}</h1>
                        <div className="breadcumb-menu-wrap">
                        </div>
                    </div>
                </div>
            </div>










            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/1.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">
                                <p className="sectionLead">{cardData.top}</p>

                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>
                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>
                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="service-row">
                                        <div className="service-icon">
                                            🚖
                                        </div>
                                        <div>
                                            <h4 className="service-title">{service.name}</h4>
                                            <p className="service-desc">{service.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title">
                                    Why Choose <span>Platinum24 Cabs</span>
                                </h2>

                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Platinum24 Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+917507048333" className="pc-call">+91 7507048333</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/917507048333"
                                                target="_blank" rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp me-1"></i> WhatsApp
                                            </a>
                                            <a href="tel:+917507048333" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@platinum24cab.com" className="pc-email">
                                            booking@platinum24cab.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-house-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Platinum24 Cabs</strong><br />
                                            OFFICE NO.2, SECTOR NO.4, PLOT NO.295(S), SAI GANGA APARTMENT, ABOVE UMED ELECTRICAL, NEAR ACORD HOSPITAL
                                            FIRST FLOOR, SANT NAGAR, MOSHI, PUNE 412105
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Punecabservice;